import React from "react";
import { Box, Container, Typography, Button, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";

import bannerFundo from "../assets/cabine.jpg";

export default function Home() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: `url(${bannerFundo})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
        px: 2,
      }}
    >
      {/* Overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, rgba(0,0,0,0.55), rgba(0,0,0,0.75))",
          backdropFilter: "blur(2px)",
        }}
      />

      <Container maxWidth="sm" sx={{ zIndex: 1 }}>
        <Stack spacing={3} alignItems="center" textAlign="center">
          <Typography
            variant="h3"
            sx={{ fontWeight: 900, color: "#fff" }}
          >
            CISE
          </Typography>

          <Typography sx={{ color: "rgba(255,255,255,0.8)", fontSize: 16 }}>
            Plataforma de gestão inteligente de leads, atendimento e performance
            da Cultura Inglesa Sergipe.
          </Typography>

          <Button
            size="large"
            variant="contained"
            onClick={() => navigate("/login")}
            sx={{
              mt: 2,
              px: 5,
              py: 1.5,
              borderRadius: 1,
              fontWeight: 800,
              backgroundColor: "var(--cise-blue)",
              "&:hover": {
                backgroundColor: "var(--cise-red)",
              },
            }}
          >
            Acesso Administrativo
          </Button>

          <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.6)" }}>
            © {new Date().getFullYear()} Cultura Inglesa Sergipe
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}